import { FC, useContext, useEffect, useState } from "react";

import YellowPlayerIdleMin from "../../../assets/avatars/avatarsHoldingCards/YellowPlayerIdleMin.png";
import PinkPlayerIdleMin from "../../../assets/avatars/avatarsHoldingCards/PinkPlayerIdleMin.png";
import BluePlayerIdleMin from "../../../assets/avatars/avatarsHoldingCards/BluePlayerIdleMin.png";
import GreenPlayerIdleMin from "../../../assets/avatars/avatarsHoldingCards/GreenPlayerIdleMin.png";

import YellowPlayerTransitionMin from "../../../assets/avatars/avatarsHandsUp/YellowPlayerTransitionMin.png";
import PinkPlayerTransitionMin from "../../../assets/avatars/avatarsHandsUp/PinkPlayerTransitionMin.png";
import BluePlayerTransitionMin from "../../../assets/avatars/avatarsHandsUp/BluePlayerTransitionMin.png";
import GreenPlayerTransitionMin from "../../../assets/avatars/avatarsHandsUp/GreenPlayerTransitionMin.png";


import { TeamContext } from "../../../context";
import { Phase } from "../../../util/enums";
import { useSound } from "../../../hooks";


interface IAvatar {
    avatarColor: string;
}

const AvatarHoldingCards: FC<IAvatar> = ({ avatarColor }) => {
    const {game} = useContext(TeamContext);
    const [isTransitionOver, setIsTransitionOver] = useState<boolean>(false);
    const {playSound} = useSound();
    
    useEffect(() => {
        const greetingSound = setTimeout(() => {
            playSound("/sounds/MusicPositive2.mp3");
        });
        return () => clearTimeout(greetingSound);

    },[playSound]);

    
    useEffect(() => {
        const greetingSound = setTimeout(() => {
            playSound("/sounds/PositiveAlert3.mp3");
        },3800);
        return () => clearTimeout(greetingSound);
     
    },[playSound]);
   

    if(game?.phase === Phase.CHOOSING_SOLUTION_CARDS){
        return (
            <div>
                {avatarColor === "avatar_yellow" && <img className="table_avatar_png_sprint_image" src={YellowPlayerTransitionMin} alt="user_avatar" />}
                {avatarColor === "avatar_pink" && <img className="table_avatar_png_sprint_image" src={PinkPlayerTransitionMin} alt="user_avatar" />}
                {avatarColor === "avatar_blue" && <img className="table_avatar_png_sprint_image" src={BluePlayerTransitionMin} alt="user_avatar" />}
                {avatarColor === "avatar_green" && <img className="table_avatar_png_sprint_image" src={GreenPlayerTransitionMin} alt="user_avatar" />}
            </div>
        )
    }
    
    if(game?.phase === Phase.PICK_DILEMMA && !isTransitionOver){
        setTimeout(() => {
            setIsTransitionOver(true);
        }, 600);
        return (
            <div>
                {avatarColor === "avatar_yellow" && <img className="table_avatar_png_sprint_transition_image table_avatar_animation_duration_holding_cards" src={YellowPlayerTransitionMin} alt="user_avatar" />}
                {avatarColor === "avatar_pink" && <img className="table_avatar_png_sprint_transition_image table_avatar_animation_duration_holding_cards" src={PinkPlayerTransitionMin} alt="user_avatar" />}
                {avatarColor === "avatar_blue" && <img className="table_avatar_png_sprint_transition_image table_avatar_animation_duration_holding_cards" src={BluePlayerTransitionMin} alt="user_avatar" />}
                {avatarColor === "avatar_green" && <img className="table_avatar_png_sprint_transition_image table_avatar_animation_duration_holding_cards" src={GreenPlayerTransitionMin} alt="user_avatar" />}
            </div>
        )
    }

    return (
        <div>
            {avatarColor === "avatar_yellow" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_holding_cards" src={YellowPlayerIdleMin} alt="user_avatar" />}
            {avatarColor === "avatar_pink" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_holding_cards" src={PinkPlayerIdleMin} alt="user_avatar" />}
            {avatarColor === "avatar_blue" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_holding_cards" src={BluePlayerIdleMin} alt="user_avatar" />}
            {avatarColor === "avatar_green" && <img className="table_avatar_png_sprint_image table_avatar_animation_duration_holding_cards" src={GreenPlayerIdleMin} alt="user_avatar" />}
        </div>
    )
}

export default AvatarHoldingCards;